import React, { useState } from 'react';
const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Form submission logic would go here
    alert('Thank you for your message. We will be in touch soon!');
    setFormData({
      name: '',
      email: '',
      phone: '',
      message: ''
    });
  };
  return <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-md" data-id="element-25">
      <div className="mb-4" data-id="element-26">
        <label htmlFor="name" className="block text-[#1A5F7A] font-medium mb-2" data-id="element-27">
          Full Name
        </label>
        <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#57C5B6]" required data-id="element-28" />
      </div>
      <div className="mb-4" data-id="element-29">
        <label htmlFor="email" className="block text-[#1A5F7A] font-medium mb-2" data-id="element-30">
          Email Address
        </label>
        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#57C5B6]" required data-id="element-31" />
      </div>
      <div className="mb-4" data-id="element-32">
        <label htmlFor="phone" className="block text-[#1A5F7A] font-medium mb-2" data-id="element-33">
          Phone Number
        </label>
        <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#57C5B6]" data-id="element-34" />
      </div>
      <div className="mb-4" data-id="element-35">
        <label htmlFor="message" className="block text-[#1A5F7A] font-medium mb-2" data-id="element-36">
          Your Message
        </label>
        <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={5} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#57C5B6]" required data-id="element-37"></textarea>
      </div>
      <button type="submit" className="w-full bg-[#1A5F7A] text-white py-3 px-6 rounded-md font-medium hover:bg-[#159895] transition-colors duration-300" data-id="element-38">
        Send Message
      </button>
    </form>;
};
export default ContactForm;